import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import Icon from "@/components/base/Icon";

interface SearchBarProps {
  initialValue?: string;
  className?: string;
  compact?: boolean;
}

export default function SearchBar({
  initialValue = "",
  className = "",
  compact = false,
}: SearchBarProps) {
  const [value, setValue] = useState(initialValue);
  const navigate = useNavigate();

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const keyword = value.trim();
    navigate(keyword ? `/search?q=${encodeURIComponent(keyword)}` : "/search");
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={`flex items-center gap-2 w-full ${className}`}
      role="search"
    >
      <div className="relative flex-1">
        <Icon
          name="ri-search-line"
          className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-foreground-400"
        />
        <input
          type="text"
          name="keyword"
          value={value}
          onChange={(event) => setValue(event.target.value)}
          placeholder="搜索漫画、作者或标签"
          aria-label="搜索漫画"
          className={`w-full rounded-md border border-background-300 bg-background-50 pl-9 pr-3 text-sm text-foreground-900 placeholder:text-foreground-400 cursor-text focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-colors ${
            compact ? "h-9" : "h-10"
          }`}
        />
      </div>
      <button
        type="submit"
        className={`shrink-0 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap px-4 cursor-pointer transition-colors hover:bg-primary-600 ${
          compact ? "h-9" : "h-10"
        }`}
      >
        搜索
      </button>
    </form>
  );
}